'use strict';

function popup(data, closeButton, button) {
    let scrollPosition;
    const ua = window.navigator.userAgent.toLowerCase();
    const isiOS = ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('macintosh') > -1 && 'ontouchend' in document;

    function bodyFixedOn() {
        if (isiOS) {
            scrollPosition = $(window).scrollTop();
            $('body').addClass('jsModalOpenedIOS');
            $('body').css('top', `-${scrollPosition}px`);
        } else {
            $('body').addClass('jsModalOpened');
        }
    }

    function bodyFixedOff() {
        if (isiOS) {
            $('body').removeClass('jsModalOpenedIOS');
            $('body').css('top', '');
            $(window).scrollTop(scrollPosition);
        } else {
            $('body').removeClass('jsModalOpened');
        }
    }

    $.magnificPopup.open({
        items: {
            src: data,
            type: 'inline',
        },
        closeOnBgClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 600,
        closeMarkup: closeButton,
        callbacks: {
            open() {
                bodyFixedOn();
            },
            close() {
                bodyFixedOff();
            },
        },
    });
}

$(() => {
    function convertStrToBool(str){
        if(typeof str !== 'string'){
          return Boolean(str);
        }
        try{
          var obj = JSON.parse(str.toLowerCase());
          return obj == true;
        }catch(e){
          return str != '';
        }
    }

    /**
     * change favorite button
     * @param {string} data - data returned from the server's ajax call
     * @param {Object} button - button that was clicked to add a product to the wishlist
     */
    function changeFavoriteButton(data, button) {
        $.spinner().stop();
        button.removeAttr('disabled');
        var url = button.data('action-url');
        var status;
        if (data.success) {
            var wasFavorite = convertStrToBool(button.attr('data-is-favorite'));
            if (wasFavorite) {
                // 登録機能に変更
                url = url.replace('Wishlist-RemoveProduct', 'Wishlist-AddProduct');
                button.attr('data-action-url', url);
                button.attr('data-action', 'Wishlist-AddProduct');
            } else {
                // 登録解除機能に変更
                url = url.replace('Wishlist-AddProduct', 'Wishlist-RemoveProduct');
                button.attr('data-action-url', url);
                button.attr('data-action', 'Wishlist-RemoveProduct');
            }
            button.attr('data-is-favorite', !wasFavorite);
            button.toggleClass('is-active');
        } else {
            // エラーメッセージの表示
        }
    }

    /**
     * appends params to a url
     * @param {string} url - Original url
     * @param {Object} params - Parameters to append
     * @returns {string} result url with appended parameters
     */
    function appendToUrl(url, params) {
        var newUrl = url;
        newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
            return key + '=' + encodeURIComponent(params[key]);
        }).join('&');

        return newUrl;
    }
    $('.button-simulation').click(function (e) {
        const $this = $(this);

        const closeBtnUrl = $(this).data('close-btn');
        const closeButton = 
            '<button title="Close (Esc)" type="button" class="mfp-close mfp-close--custom" onclick="$.magnificPopup.close();"><img src="'
        +   closeBtnUrl
        +   '"></button>';

        $.ajax({
            url: $this.attr('href'),
            type: 'get',
            data: [],
        }).done((data) => {
            var $data = $(data);
            if ($data.find('input[name=modal-installment-radio]:checked').length === 0) {
                $data.find('input[name=modal-installment-radio]:not(:disabled)').attr('checked', true);
                popup($data.prop('outerHTML'), closeButton, $this);
                // Trigger the change event after setting to popup to recalculate the price table
                $('input[name=modal-installment-radio]').trigger('change');
            } else {
                popup(data, closeButton, $this);
            }
        }).fail((data) => {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                createErrorNotification(data);
                $.spinner().stop();
            }
        });

        e.preventDefault();
        return false;
    });

    $('.product-youtube').on('click', function (e) {
        var video = '<iframe src="'+ jQuery(this).attr('data-video') + '?autoplay=true&rel=0' +'" frameborder="0" width="100%" height="538"></iframe>';
        $(this).replaceWith(video);
    });

    $('.button-favorite').on('click', function (e) {
        e.preventDefault();
        var button = $(this);
        // キャッシュからではなく最新の状態を取得する。
        var pid = $(this).attr('data-pid');
        var uuid = $(this).attr('data-uuid');
        var url = $(this).attr('data-action-url');
        var action = $(this).attr('data-action');
        var optionId = null;
        var optionVal = null;

        // URLまたは商品IDが取得できない場合は画面に戻す。
        if (!url || !pid) {
            return;
        }

        // dataの作成
        var data = {
            pid: pid,
            uuid: uuid,
            optionId: optionId,
            optionVal: optionVal
        };


        $.spinner().start();
        button.attr('disabled', true);
        // Actionで処理を分岐。
        // Wishlistへの商品追加、商品削除のパターンあり
        if (action === 'Wishlist-AddProduct') {
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: data,
                success: function (data) {
                    // Add error handling for add wishlist product
                    if(data.error) {
                        createErrorNotification({
                            responseJSON: { message: data.msg },
                        });
                    } else {
                        changeFavoriteButton(data, button);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err);
                        $.spinner().stop();
                    }
                }
            });
        } else if (action === 'Wishlist-RemoveProduct') {
            url = appendToUrl(url, data);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    // Add error handling for remove wishlist product
                    if(data.error) {
                        createErrorNotification({
                            responseJSON: { message: data.msg },
                        });
                    } else {
                        changeFavoriteButton(data, button);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('.product-content__detail-col-slider__items').on('init', (event, slick) => {
        $('#my-gallery').css('display', 'block');
    });
    $('.product-content__detail-col-slider__items').slick({
        lazyLoad: 'ondemand',
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1, // Set number of slides to 1, the remaining will be automatically loaded based on slider's width
        centerMode: false,
        variableWidth: true,
    });

    // Handler for afterChange event on element with ID my-gallery
    $('#my-gallery').on('afterChange', () => {
        // Select all slides after the current slide
        let imgNeedsToLoad = $('div#my-gallery div.slick-current').nextAll('.slick-slide');
        // Iterate through all slides
        for(let i = 0; i < $('div.slick-track').data('num-slides'); i++) {
            // Set slides for each iteration
            setSlides($(imgNeedsToLoad[i]).find('img'));
        }
    });
     // Load event for slider images
     $('div#my-gallery img.pswp__original_img').on('load', (ev) => {
        setSlides(ev.currentTarget);
    });
});

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
 function displayMessage(data, button) {
    // TODO: メッセージ部分の実装
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
           '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

 /**
 * Set the slides in the product slider.
 *
 * @param {jQuery} img - The image element that triggered the function.
 * @returns {void}
 */
function setSlides(img) {
    const sliderWidth = $('div.product-content__detail-col-slider').width();
    let totalImageWidth = 0;
    let _this = img;
    let numSlides = 0;
    $('div#my-gallery div.slick-current').nextAll('.slick-active').find('img').each(function(ind, item) {
        totalImageWidth += $(item).outerWidth();
        numSlides++;
    });
    // if the total width of images is less than desired width, trigger load event for next image
    if (totalImageWidth < sliderWidth) {
        $('button.slick-next').show();
        let nextDiv = $(_this).closest('div.slick-slide').next('div');
        let nextImg = nextDiv.find('img');
        if (nextImg.length && !!nextImg.data('lazy')) {
            nextImg[0].src = nextImg.data('lazy');
            nextImg.removeAttr('data-lazy').removeClass('slick-loading');
            nextDiv.addClass('slick-active').removeAttr('tabindex').attr('aria-hidden', false);
        }
    } else {
        $('div.slick-track').attr('data-num-slides', numSlides+1); // update number of slides into parent
    }
}
/**
 * displa popup of Error
 * @param {Object} err - Error data
 */
 function createErrorNotification(errData) {
    // 警告メッセージダイアログ
    var dialog = '<div class="modal-base modal-product-wrapper jsModalContentOuter">';
    dialog += '<div class="modal-product__description">' + errData.responseJSON.message + '</div>';
    dialog += '<ul class="modal-product-buttons">';
    dialog += '<li><button type="button" class="button-gray btn-close">Close</button></li>';
    dialog += '</ul>';
    dialog += '</div>';

    $.magnificPopup.open({
        items: {
            src: dialog,
            type: 'inline'
        },
        closeOnBgClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 600,
        callbacks: {
            open: function() {
                var $content = $(this.content);

                $content.on('click', '.btn-close', function() {
                    $.magnificPopup.close();
                    $(document).off('keydown', keydownHandler);
                });

                var keydownHandler = function (e) {
                    if (e.keyCode == 27) {
                        $content.find('.btn-close').click();
                        return false;
                    }
                };
                $(document).on('keydown', keydownHandler);
            }
        }
    });
}
